import $RefParser from '@apidevtools/json-schema-ref-parser'
import { defaultsAjv } from './JsonForm'
import type { ErrorObject } from '@jsonforms/core/node_modules/ajv/lib/ajv'

export const defaultRefResolver = async (schema: any) => {
  return await $RefParser.dereference(schema)
}

export const parseErrorsAsString = (errors: ErrorObject[]) => {
  return defaultsAjv.errorsText(errors, { dataVar: '', separator: ' | ' })
}

export const stripNullValues = (value: any): any => {
  if (Array.isArray(value)) {
    let changed = false
    const next = value.map(item => {
      const stripped = stripNullValues(item)
      if (stripped !== item) changed = true
      return stripped
    })
    // Preserve reference so JsonForms can recognize its own emitted data
    return changed ? next : value
  }
  if (value !== null && typeof value === 'object') {
    let changed = false
    const result: Record<string, any> = {}
    for (const [key, val] of Object.entries(value)) {
      if (val === null) {
        changed = true
        continue
      }
      const stripped = stripNullValues(val)
      if (stripped !== val) changed = true
      result[key] = stripped
    }
    // Preserve reference so JsonForms can recognize its own emitted data
    return changed ? result : value
  }
  return value
}
